import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatepickerOptions, TemporalType } from '@novalinc/datepicker';
import { NotificationsService } from 'angular2-notifications';
import { ExamSummary, Intake, Patient, ScheduleRequest, ScheduleResponse, AvailableProviderQueue, Timezone, ProviderScheduleForPatient, ProviderScheduleSearch } from '../models';
import { Api, Session } from '../services/index';
import * as momenttz from 'moment-timezone';
@Component({
  selector: 'app-exam-appointment',
  templateUrl: './exam-appointment.html'
})

export class ExamAppointment implements OnInit {
  // appointmentDate: Date = new Date();
  // patientId: number;
  // schedRequest: ScheduleRequest = new ScheduleRequest();
  // visitOptions: DatepickerOptions;
  // requestedProviderId: number;
  // requestedVisitType: string;
  // requestScheduleToChange: ProviderScheduleForPatient;
  // scheduleResults: Array<AvailableProviderQueue>;

  // timezone: Timezone = (momenttz.tz.zone(momenttz.tz.guess()));
  // timezoneAbbr: string;
  // isDST: boolean;

  // curDate: String;
  // minDate: String;
  // maxDate: String;
  // myDate: Date = new Date();

  // isScheduleReady: boolean;


  constructor(private api: Api,
              private route: ActivatedRoute,
              private router: Router,
              private service: NotificationsService,
              private session: Session) {
    // this.patientId = this.route.snapshot.params['patientId'] || '';
    // if (this.session.providerBio !== null) {
    //   this.requestedProviderId = parseInt( this.session.providerBio.providerUserId );
    //   console.log('this.requestedProviderId:', this.requestedProviderId );
    // }

    // if(this.session.intakeBhVisitModality){
    //   this.requestedVisitType = this.session.intakeBhVisitModality;
    // }else{
    //   this.requestedVisitType = 'Phone';
    // }
  

  }

  ngOnInit() {
    // this.appointmentDate.setDate(this.appointmentDate.getDate() + 2);
    // this.visitOptions = new DatepickerOptions();
    // this.visitOptions.temporal = TemporalType.TIMESTAMP;
    // this.visitOptions.future = true;
    // this.visitOptions.placeholder = 'Visit Date and Time';



    // let myDate = new Date();
    // let startSearchDate = new Date();
    // let endSearchDate = myDate.setMonth(myDate.getMonth() + 2);

    // this.curDate = momenttz(myDate).format('YYYY-MM-DD');

    // let providerSearch = new ProviderScheduleSearch();
    // providerSearch.startDate = new Date(startSearchDate);
    // providerSearch.endDate = new Date(endSearchDate);
    // providerSearch.stateAbbr = this.session.clientIntake.currentState;
    // providerSearch.lineOfBusiness = this.session.clientIntake.lineOfBusiness;

    // if(this.requestedProviderId){
    //   providerSearch.providerId = Number(this.requestedProviderId);
    // }
    // this.api.getProviderAvailabilityQueue(providerSearch).subscribe(res => {

    //   this.scheduleResults = res;
    //   let scheduleFilterResults = this.scheduleResults;
    //   if (this.requestedVisitType) {
    //     let filterVisitType = '';
    //     if(this.requestedVisitType === 'Video'){
    //       filterVisitType = 'Available Video/Phone';
    //       scheduleFilterResults = this.scheduleResults.filter((scheduleEvent: any) => scheduleEvent.visitType === filterVisitType);
    //       this.scheduleResults = scheduleFilterResults;
    //     }
    //   }
    //   this.scheduleResults.forEach(item => {
    //     let evtStartTime = momenttz.tz(item.shiftStart, this.timezone.name).format();
    //     let evtEndTime = momenttz.tz(item.shiftEnd, this.timezone.name).format();
    //     let scheduleDescription = '';
    //     if (item.visitType === 'Available Video/Phone') {
    //       scheduleDescription = '<p style="color: #000; font-size: .714286em;"><span style="color: #000"><strong>Providers Name:</strong></span> ' + item.fullName + '</p><p style="color: #009933; font-size: .714286em;"><span style="color: #000"><strong>Available Visit Type:</strong></span>  Phone or Video </p>';
    //     } else {
    //       scheduleDescription = '<p style="color: #000; font-size: .714286em;"><span style="color: #000"><strong>Providers Name:</strong></span> ' + item.fullName + '</p><p style="color: #0080bb; font-size: .714286em;"><span style="color: #000"><strong>Available Visit Type:</strong></span>  Phone Only</p>';
    //     }

    //     let newAvailable = {
    //       'providerId': item.providerId,
    //       'start': evtStartTime,
    //       'end': evtEndTime,
    //       'text': scheduleDescription,
    //       'scheduleSource': item
    //     }

    //     //this.myevents.push(newAvailable);
    //   });
    //   if (this.session.providerBio) {
    //     // providerSearch.providerId = Number(this.requestedProviderId);
    //     // let filterBy = providerSearch.providerId;
    //     // this.myFilteredEvents = this.myevents;
    //     // let filteredResults = this.myFilteredEvents.filter((event: any) => event.providerId === filterBy);
    //     // this.myevents = filteredResults;
    //   }


    //   this.isScheduleReady = true;





   // });


  }

  continue() {
    // this.schedRequest.patientId = Number(this.patientId);
    // this.schedRequest.requestedAppointmentDate = this.appointmentDate.toJSON();
    // this.schedRequest.providerId = this.requestedProviderId;

    // this.api.updateScheduleRequestforIntake(this.session.serverIntake.intakeId, this.schedRequest).subscribe(res => {
    //   this.router.navigate(['/exam-select-pharmacy/' + this.patientId]);
    // }, (error) => {
    //   this.service.error('MeMD does not currently provide Behavioral Health services to your state. We are expanding our network to include all 50 states, please check back soon!');
    // });
  }

}
